import Pusher from 'pusher-js'
import { ReactNode } from 'react'

import { PusherContext } from './Context'

interface PusherProviderProps {
  children: ReactNode
  pusherKey: string
  pusherCluster: string
}

let pusher: Pusher | null = null

const getPusher = ({
  pusherKey,
  pusherCluster,
}: {
  pusherKey: string
  pusherCluster: string
}) => {
  if (pusher) {
    return pusher
  }

  pusher = new Pusher(pusherKey, {
    cluster: pusherCluster,
    pongTimeout: 1_000,
  })

  return pusher
}

export const PusherProvider = ({
  children,
  pusherKey,
  pusherCluster,
}: PusherProviderProps) => (
  <PusherContext.Provider value={getPusher({ pusherKey, pusherCluster })}>
    {children}
  </PusherContext.Provider>
)
